
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UseAuth } from "./AuthContext";

import "./css/NavigationBar.css"


export function NavigationBar()
{
    const {company, Logout} = UseAuth();
    let navigate = useNavigate();

    const GoToInstructionVideo = () => {
        window.open("https://youtu.be/gfbZW7K6Ofk", "_blank");
    }

    return (
        <div className="navbar">
            <h2>MERSE</h2>
            <div className="navbar-options">
                {/* <div className="navbar-search">
                    <p>Search</p>
                    <input type="text"></input>
                </div> */}
                {
                    company ? (    
                        <div className="navbar-user">
                            <p>{company.companyName}</p>
                            <p className="navbar-dashboard" onClick={() => {navigate("/dashboard")}}>Dashboard</p>
                            <p className="navbar-login" onClick={Logout}>Logout</p>
                        </div>
                    ) : (
                        <p className="navbar-login" onClick={() => {navigate("/SignIn")}}>Log in</p>
                    )
                }
                <p className="navbar-login" onClick={GoToInstructionVideo}>Instruction Video</p>
                <div className="navbar-language" onClick={() => alert("More options for language are upcoming.")}>
                    <p>English</p>
                    <img src="https://flagcdn.com/w20/us.png" alt="English flag"></img>
                </div>
            </div>
        </div>
    );
}